﻿import { onEvent } from "./_dom";
import { postback } from "./_fs";

function initFilterRow(row) {
	const action = row.getAttribute("fs-action") || "filter";
	const doPostback = e => postback(e.target.form, null, action, false);
	onEvent(row, "input, select", "change", doPostback);
	onEvent(row, "input", "keydown", e => {
		if (e.key == "Enter") {
			e.stopPropagation();
			doPostback(e);
		}
	});
}
/*
function initQuickSearch(g) {
grids.filter(".fs-quicksearch").each(function () {
	var g = $(this);
	g.find(">thead>tr>td")
		.append(
			$("<span/>", { "class": "fs-quicksearch" })
				.append($("<input placeholder=\"Quick Search...\">")
					.quicksearch({ selector: g })));
});
}
*/

function initTableFilters(context, selector = ".v3-tableview__head-filter-row") {
	(context || document).querySelectorAll(selector).forEach(filterRow =>
		initFilterRow(filterRow)
	);
}

export { initTableFilters as init };
